import React from "react";

const ItemImagePopup = ({ onClosePopup, imageSrc }) => {
  return (
    <div>
      <div className="modal-bg" />
      <div className="modal item-image">
        {/* Header */}
        <div className="head-general with-back item-image">
          <a href="javascript: void(0)" />
          <h4 className="info-title" />
          <a
            href="javascript: void(0)"
            onClick={onClosePopup}
            className="close"
          >
            <icon className="icon icon-close-white" />
          </a>
        </div>
        {/* Header */}
        <div className="modal-body item-image">
          <img style={{ width: "100%" }} src={imageSrc} />
        </div>
      </div>
    </div>
  );
};

export default ItemImagePopup;
